module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin-700.0edb7628.woff2";